import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {LoggerService} from "../../services/logger/logger-service/logger.service";
import {Role} from "../../auth/roles.enum";
import {UserService} from "../../auth/user-service/user.service";

/**
 * Checks that user has 'registered' role.
 * If not - redirects to forbidden page.
 * @param route
 * @param state
 */
export const registeredGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  if (userService.role() === Role.REGISTERED) {
    logger.debug("Registered user route guard passed.")
    return true;
  }

  logger.debug("Registered user route guard failed.")
  router.navigate(["/unauthorised"]);
  return false;
};
